import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient, HttpContext } from '@angular/common/http';
import { SKIP_STATUS_CODES } from '../common/interceptors/error-response-handler.interceptor';
import { map, Observable, Subject } from 'rxjs';
import { BuildingInsights } from '../common/models/maps/building-insights';

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsService {

  public readonly mapsApiKey: string = environment.mapsApiKey;

  private readonly solarApiBaseUrl: string = 'https://solar.googleapis.com/v1/';

  constructor(
    private httpClient: HttpClient,
  ) {
  }

  getSolarBuildingInsights(location: google.maps.LatLngLiteral) {
    return this.httpClient.get(`${ this.solarApiBaseUrl }buildingInsights:findClosest?` +
      `location.latitude=${ location.lat }&` +
      `location.longitude=${ location.lng }&` +
      `requiredQuality=HIGH&` +
      `key=${ this.mapsApiKey }`,
      {
        context: new HttpContext().set(SKIP_STATUS_CODES, [404]),
      }).pipe(
      map((response) => response as BuildingInsights),
    );
  }


  getSolarDataLayer(location: google.maps.LatLngLiteral) {
    return this.httpClient.get(`${ this.solarApiBaseUrl }dataLayers:get?` +
      `location.latitude=${ location.lat }&` +
      `location.longitude=${ location.lng }&` +
      `requiredQuality=HIGH&` +
      `key=${ this.mapsApiKey }`,
      {
        context: new HttpContext().set(SKIP_STATUS_CODES, [404, 403]),
      });
  }

  getAddressFromLatLngPromise(latLng: google.maps.LatLngLiteral): Observable<google.maps.GeocoderResult[]> {
    const geocoder = new google.maps.Geocoder();
    const resultSubject = new Subject<google.maps.GeocoderResult[]>();


    geocoder.geocode(
      { location: latLng },
      (results, status) => {
        if (status === 'OK') {
          resultSubject.next(results || []);
          resultSubject.complete();
        } else {
          resultSubject.error(status);
        }
      },
    );

    return resultSubject.asObservable();
  }


}
